import { Role } from '../models/auth.dto';

export function canReviewCompanies(role?: Role): boolean {
  return role === 'SUPERADMIN' || role === 'ADMIN';
}

export function canManagePlatformUsers(role?: Role): boolean {
  return role === 'SUPERADMIN';
}

export function canManageProjects(role?: Role): boolean {
  return role === 'COMPANY_ADMIN' || role === 'COMPANY_USER';
}

export function canViewProjects(role?: Role): boolean {
  return (
    canManageProjects(role) || role === 'SUPERADMIN' || role === 'ADMIN' || role === 'CUSTOMS' || role === 'AUDITOR'
  );
}

export function canManageApiKeys(role?: Role): boolean {
  return role === 'COMPANY_ADMIN';
}

export function canManageCompanyUsers(role?: Role): boolean {
  return role === 'COMPANY_ADMIN';
}

export function canViewOwnWallet(role?: Role): boolean {
  return canManageProjects(role);
}

export function canViewPlatformWallet(role?: Role): boolean {
  return role === 'SUPERADMIN';
}

export function canViewPlatformConfig(role?: Role): boolean {
  return role === 'SUPERADMIN' || role === 'ADMIN' || role === 'AUDITOR';
}

export function canViewCountrySchema(role?: Role): boolean {
  return canViewPlatformConfig(role) || canManageProjects(role);
}

export function canViewOwnCompany(role?: Role): boolean {
  return canManageProjects(role);
}

export function canViewPlatformDiagnostics(role?: Role): boolean {
  return canViewPlatformConfig(role);
}

export function canViewPlatformExportRequests(role?: Role): boolean {
  return role === 'SUPERADMIN' || role === 'ADMIN' || role === 'CUSTOMS' || role === 'AUDITOR';
}
